import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BDiseaseFetchListCard } from './BDiseaseFetchListCard'

export const BDiseasePopperListCard = defineComponent({
  name: 'BDiseasePopperListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
    popoverTrigger: {
      type: String as PropType<'hover' | 'click'>,
      default: 'click',
    },
    coreIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  render() {
    return (
      <PtPopper
        data={{ ids: this.ids, coreIds: this.coreIds }}
        tippyConfig={getAsyncListTippyConfig(this.popoverTrigger)}
        component={BDiseaseFetchListCard}
      >
        {this.$slots.default}
      </PtPopper>
    )
  },
})
